function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
  fill: "#F05B3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.8582 54.4707C31.8582 55.594 32.7688 56.5046 33.8921 56.5046H62.5789C63.7022 56.5046 64.6128 55.594 64.6128 54.4707V52.5767H31.8582V54.4707Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.4895 58.3955C35.4895 59.5187 36.4001 60.4294 37.5234 60.4294H58.9482C60.0715 60.4294 60.9821 59.5187 60.9821 58.3955V56.5049H35.4895V58.3955Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1365 24.5983C28.5552 24.9727 28.2039 25.6168 28.2039 26.3083V50.5426C28.2039 51.6659 29.1145 52.5765 30.2378 52.5765H66.2341C67.3574 52.5765 68.268 51.6659 68.268 50.5426L68.2675 26.3079C68.2675 25.6165 67.9162 24.9724 67.3348 24.598L49.3375 13.0075C48.6669 12.5756 47.8057 12.5756 47.1351 13.0075L29.1365 24.5983Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.8035 27.2044C65.5629 26.7237 65.5596 25.6147 64.7974 25.1385L48.891 15.1996C48.4923 14.9505 47.986 14.9525 47.5893 15.2048L31.8618 25.2086C31.1081 25.6881 31.1079 26.7882 31.8614 27.2678L47.585 37.276C47.9839 37.5299 48.4935 37.5305 48.893 37.2776L64.8035 27.2044Z",
  fill: "#F05B3A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.2046 87.2418C48.2046 87.2418 51.626 84.9315 54.3672 81.142C55.7508 79.2302 56.96 76.9421 57.4688 74.3827C58.987 66.7555 54.4328 63.0508 48.2046 63.0508C41.9742 63.0508 37.4207 66.7555 38.9375 74.3827C40.4562 82.0118 48.2046 87.2418 48.2046 87.2418Z",
  fill: "#FFE600"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.3189 77.8844C48.3189 77.8844 44.1033 75.0298 43.2786 70.8651C42.4527 66.6994 44.9294 64.6777 48.3189 64.6777C51.7068 64.6777 54.1844 66.6994 53.3578 70.8651C52.5327 75.0298 48.3189 77.8844 48.3189 77.8844Z",
  fill: "#F05B3A"
});

function SvgYammLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYammLogotype);
export default __webpack_public_path__ + "static/media/YAMM-Logotype.d873f3ec.svg";
export { ForwardRef as ReactComponent };